<template>
  <div>
    <b-card title="Kostenfreie Zusatzoptionen">
      <validation-observer ref="phonebookForm">
        <b-form-checkbox
            class="mb-1"
            v-model="CHECKOUT_DATA.itemization"
        >
          Einzelverbindungsnachweis
        </b-form-checkbox>

        <div v-if="CHECKOUT_DATA.itemization">
          <div class="inner-section">
            <p>
              Zeigt die einzelnen Verbindungen auf der Telefonrechnung an, die gewählten Rufnummern
              sowie die Zeiten, zu denen man telefoniert hat. Standardmäßig werden diese Verbindungen
              gekürzt angezeigt, d. h. die letzten drei Ziffern einer Rufnummer sind als &bdquo;XXX&rdquo; zu sehen.
              Wählen Sie ungekürzt für vollständig angezeigte Nummern.
            </p>

            <p class="mt-2">
              <strong>Auf dem Einzelverbindungsnachweis sollen die Rufnummern der Verbindungen,
                für die ich entgeltpflichtig bin, wie folgt angezeigt werden.:</strong>
            </p>


            <b-form-radio-group
                v-model="CHECKOUT_DATA.itemization_type"
                stacked
                class="mb-1"
            >
              <b-form-radio value="short">
                Gekürzt (z. B. 030-123456XXX)
              </b-form-radio>
              <b-form-radio value="full">
                Ungekürzt (z. B. 030-123456789)
              </b-form-radio>
            </b-form-radio-group>
          </div>
          <hr>
        </div>
        <!--        <ValidationProvider rules="" vid="active">-->
        <!--          <b-form-checkbox v-model="CHECKOUT_DATA.separateDeliveryAddress.selected">-->
        <!--            Lieferanschrift (für Hardware o. ä.)-->
        <!--          </b-form-checkbox>-->
        <!--        </ValidationProvider>-->
        <div v-for="entry in CHECKOUT_DATA.phoneline.phonebook" :key="entry.index">
          <hr v-if="entry.index > 0 && CHECKOUT_DATA.phoneline.phonebook[0].selected"/>
          <ValidationProvider rules="" :vid="'active_entry_'+entry.index">
            <b-form-checkbox
                v-model="entry.selected"
                v-if="entry.index == 0 || CHECKOUT_DATA.phoneline.phonebook[0].selected"
                vid="active"
            >
              <template v-if="entry.index > 0">
                weiterer
              </template>
              Telefonbucheintrag
            </b-form-checkbox>
          </ValidationProvider>

          <div
              class="pl-1 mt-1"
              v-if="(entry.index > 0 && CHECKOUT_DATA.phoneline.phonebook[0].selected && entry.selected) || (entry.index == 0 && entry.selected)"
          >
            <p>
              Ich wünsche die Aufnahme meiner Daten wie folgt (Mehrfachnennung möglich)
            </p>

            <b-form-checkbox
                class="mb-1"
                v-model="entry.print_entry"
            >
              Eintrag in das gedruckte Telefonbuch.
            </b-form-checkbox>
            <b-form-checkbox
                class="mb-1"
                v-model="entry.electronic_entry"
            >
              Eintrag in die elektronischen Auskunftsmedien.
            </b-form-checkbox>
            <!--            <b-form-checkbox-->
            <!--                class="mb-1"-->
            <!--                v-model="entry.phone_entry"-->
            <!--            >-->
            <!--              Eintrag bei der telefonischen Auskunft-->
            <!--            </b-form-checkbox>-->
            <b-form-checkbox
                class="mb-1"
                v-model="entry.rejectinverse_entry"
            >
              Ich widerspreche der Rückwärts-/Inverssuche.
              <b-avatar
                  class="mr-1 question-mark"
                  variant="secondary"
                  size="sm"
                  v-b-tooltip.hover.top="'Übermittelung von Name und Anschrift über Rufnummer'"
                  text="?"
              >
              </b-avatar>
            </b-form-checkbox>

            <b-row>
              <b-col md="6">
                <b-form-group label="Firma (optional)" :label-for="'phonebook-entry-' + entry.index + '-address-firm'">
                  <b-form-input
                      :id="'phonebook-entry-' + entry.index + '-address-firm'"
                      v-model="entry.firm"
                      placeholder="Bitte geben Sie den Namen der Firma an."
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group label="Vorname" class="required"
                              :label-for="'phonebook-entry-' + entry.index + '-address-firstname'">
                  <validation-provider
                      #default="{ errors }"
                      name="Vorname"
                      :rules="'required_if:active_entry_'+entry.index+',true|max:30'"
                      :vid="'phonebook-entry-' + entry.index + '-address-firstname'"
                  >
                    <b-form-input
                        :id="'phonebook-entry-' + entry.index + '-address-firstname'"
                        v-model="entry.firstname"
                        placeholder="Bitte geben Sie Ihren Vornamen an."
                    />
                    <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Name" class="required"
                              :label-for="'phonebook-entry-' + entry.index + '-address-name'">
                  <validation-provider
                      #default="{ errors }"
                      name="Name"
                      :rules="'required_if:active_entry_'+entry.index+',true|max:30'"
                      :vid="'phonebook-entry-' + entry.index + '-address-name'"
                  >
                    <b-form-input
                        :id="'phonebook-entry-' + entry.index + '-address-name'"
                        v-model="entry.name"
                        placeholder="Bitte geben Sie Ihren Namen an."
                    />
                    <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="9">
                <b-form-group label="Straße" class="required"
                              :label-for="'phonebook-entry-' + entry.index + '-address-street'">
                  <validation-provider
                      #default="{ errors }"
                      name="Straße"
                      :rules="'required_if:active_entry_'+entry.index+',true'"
                      :vid="'phonebook-entry-' + entry.index + '-address-street'"
                  >
                    <b-form-input
                        :id="'phonebook-entry-' + entry.index + '-address-street'"
                        v-model="entry.street"
                        placeholder="Bitte geben Sie eine Straße an."
                    />
                    <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Hausnummer" class="required"
                              :label-for="'phonebook-entry-' + entry.index + '-address-housenumber'">
                  <validation-provider
                      #default="{ errors }"
                      name="Hausnummer"
                      :rules="'required_if:active_entry_'+entry.index+',true'"
                      :vid="'phonebook-entry-' + entry.index + '-address-housenumber'"
                  >
                    <b-form-input
                        :id="'phonebook-entry-' + entry.index + '-address-housenumber'"
                        v-model="entry.housenumber"
                        placeholder="Bitte geben Sie eine Hausnummer an."
                    />
                    <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="PLZ" class="required"
                              :label-for="'phonebook-entry-' + entry.index + '-address-postal'">
                  <validation-provider
                      #default="{ errors }"
                      name="PLZ"
                      :rules="'required_if:active_entry_'+entry.index+',true'"
                      :vid="'phonebook-entry-' + entry.index + '-address-postal'"
                  >
                    <b-form-input
                        :id="'phonebook-entry-' + entry.index + '-address-postal'"
                        v-model="entry.postcode"
                        placeholder="Bitte geben Sie eine PLZ an."
                    />
                    <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="9">
                <b-form-group label="Ort" class="required"
                              :label-for="'phonebook-entry-' + entry.index + '-address-city'">
                  <validation-provider
                      #default="{ errors }"
                      name="Ort"
                      :rules="'required_if:active_entry_'+entry.index+',true'"
                      :vid="'phonebook-entry-' + entry.index + '-address-city'"
                  >
                    <b-form-input
                        :id="'phonebook-entry-' + entry.index + '-address-city'"
                        v-model="entry.city"
                        placeholder="Bitte geben Sie einen Ort an."
                    />
                    <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-button variant="primary" size="sm" @click="copyAdressData(entry)">Kontaktdaten vom Anschlussinhaber
              übernehmen
            </b-button>
          </div>
        </div>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  BFormRadioGroup,
  BFormRadio
} from "bootstrap-vue";
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {required, required_if, email, digits} from '@validations'

export default {
  name: "PhoneBookSection",
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormRadioGroup,
    BFormRadio
  },
  data() {
    return {
      address: {},
      value: [],
      showMoreNumbers: false,
      transferNumbers: false,
    }
  },
  computed: {
    ...mapGetters(['SERVICE', 'CHECKOUT_DATA', 'BILLING_ADDRESS']),
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
    validateForm() {
      this.$refs.phonebookForm.validate()
    },
    /**
     * @returns {number}
     */
    minDate() {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      // 15th two months prior
      const minDate = new Date(today)
      return minDate
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      const weekday = date.getDay()
      const day = date.getDate()
      const month = date.getMonth()

      let eastern = this.getEaster(date.getFullYear())
      let days = [-2, 0, 1, 39, 49, 50]

      let disableDay = false
      days.forEach(item => {
        let currentDate = new Date(eastern.getTime() + (item * 24 * 60 * 60 * 1000));
        if (currentDate.toDateString() == date.toDateString()) {
          disableDay = true
          return true
        }
      })

      return weekday === 0 || weekday === 6 ||
          (month === 11 && (day === 24 || day === 25 || day === 26 || day === 31)) ||
          (month === 9 && day === 3) || (month === 4 && day === 1) || disableDay
    },
    getEaster(year) {
      let f = Math.floor,
          // Golden Number - 1
          G = year % 19,
          C = f(year / 100),
          // related to Epact
          H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
          // number of days from 21 March to the Paschal full moon
          I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
          // weekday for the Paschal full moon
          J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
          // number of days from 21 March to the Sunday on or before the Paschal full moon
          L = I - J,
          month = 3 + f((L + 40) / 44),
          day = L + 28 - 31 * f(month / 4);

      let date = new Date(year, month - 1, day);

      return date;
    },
    copyAdressData(entry) {
      entry.firstname = this.BILLING_ADDRESS.firstname
      entry.name = this.BILLING_ADDRESS.name
      entry.street = this.BILLING_ADDRESS.street
      entry.housenumber = this.BILLING_ADDRESS.housenumber
      entry.postcode = this.BILLING_ADDRESS.postcode
      entry.city = this.BILLING_ADDRESS.city
    }
  }

}
</script>

<style scoped>

</style>
